import { css, createGlobalStyle } from 'styled-components';
import { nestedPropExists } from '@movember/mo-gel/utils/validation';
import { normaliseColor } from '@movember/mo-gel/utils/colors';

const globalImports = css`
  @import url('https://fonts.googleapis.com/css?family=Overpass:400,700&display=swap');
`;

/*
  REFERENCE: Point 4 in https://www.styled-components.com/docs/api#createglobalstyle
*/
export const RootStyle = createGlobalStyle`
${globalImports}
:root {
  color: ${(props) => {
    return (
      (nestedPropExists(props.theme, 'typography', 'defaultColors') &&
        normaliseColor(props.theme.typography.defaultColors, props.theme)) ||
      (nestedPropExists(props.theme, 'colors') && props.theme.colors.primaryFont)
    );
  }}

  body {
    margin: 0;
    padding: 0;
    background: ${(props) => props.theme.colors.brandThemeDark900};
    overflow: ${(props) => (props.isBlurred ? 'hidden' : 'scroll')};
    width: 100%;
    box-sizing: border-box;
  }

  font-family: ${(props) => props.theme.defaultFontFamily};
  font-size: ${(props) =>
    nestedPropExists(props.theme, 'typography', 'baseFontSize', 'xxs') &&
    props.theme.typography.baseFontSize.xxs};
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.xs}) {
    font-size: ${(props) =>
      nestedPropExists(props.theme, 'typography', 'baseFontSize', 'xs') &&
      props.theme.typography.baseFontSize.xs};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm}) {
    font-size: ${(props) =>
      nestedPropExists(props.theme, 'typography', 'baseFontSize', 'sm') &&
      props.theme.typography.baseFontSize.sm};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.md}) {
    font-size: ${(props) =>
      nestedPropExists(props.theme, 'typography', 'baseFontSize', 'md') &&
      props.theme.typography.baseFontSize.md};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.lg}) {
    font-size: ${(props) =>
      nestedPropExists(props.theme, 'typography', 'baseFontSize', 'lg') &&
      props.theme.typography.baseFontSize.lg};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.xl}) {
    font-size: ${(props) =>
      nestedPropExists(props.theme, 'typography', 'baseFontSize', 'xl') &&
      props.theme.typography.baseFontSize.xl};
  }
}
`;
